import { UrlQueryParamsInterface } from './query-params.interface';

/**
 * Serialize Params into valid URL queryString
 *
 * @param urlQueryParams
 */
export function urlSerializeParams(urlQueryParams: UrlQueryParamsInterface): string {
  return Object.keys(urlQueryParams)
    .sort()
    .map((key: string) => {
      // Array value
      if (Array.isArray(urlQueryParams[key])) {
        return urlQueryParams[key]
          .map((value: string) => {
            return `${encodeURIComponent(key)}[]=${encodeURIComponent(value)}`;
          })
          .join('&');

        // Object value
      } else if (urlQueryParams[key] instanceof Object) {
        const paramObj = urlQueryParams[key];

        return Object.keys(paramObj)
          .map((subKey) => {
            return (
              `${encodeURIComponent(key)}[${encodeURIComponent(subKey)}]` + `=${encodeURIComponent(paramObj[subKey])}`
            );
          })
          .join('&');
        // Single value
      } else {
        return `${encodeURIComponent(key)}=${encodeURIComponent(urlQueryParams[key])}`;
      }
    })
    .filter((value: string) => !!value)
    .join('&');
}
